import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl, Table } from 'react-bootstrap';
import apiFetch from "../utils/apiFetch";
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPause, faPlay, faTrashAlt, faPen, faArrowUp, faArrowDown} from '@fortawesome/free-solid-svg-icons'
import photoUpload from "../utils/photoUpload";

class Covers extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            covers: null,
            update_interval: 0
        }
        this.loadCovers()
    }

    loadCovers = () => {
        apiFetch('covers.get', {
            login: localStorage.getItem('login'),
            password: localStorage.getItem('password')
        }).then((result) => {
            console.log(result);
            if (!result.success) {
                this.setState({need_login: true});
                window.location.replace("/auth");
            } else {
                console.log('auth is okey')
                this.setState({covers: result.items, update_interval: result.update_interval})
            }
        })
    }

    uploadCovers = () => {
        let files = document.getElementById('coversUpload').files;
        photoUpload(files).then((result) => {
                console.log(result)
                this.loadCovers()
                alert("Новые обложки загружены")
        });
    }

    deleteCover = (cover_id) => {
        if(confirm('Вы действительно хотите удалить?')) {
            let covers = this.state.covers;
            let cover_key = 0;
            covers.forEach((cover, key) => {
                if (cover.id == cover_id) {
                    cover_key = key;
                }
            });
            console.log(cover_key);
            apiFetch('covers.delete', {
                cover_id: cover_id
            }).then((result) => {
                covers.splice(cover_key, 1);
                this.setState({covers: covers});
            });
        }

    }

    changePosition = (cover_id, direction) => {
        apiFetch('covers.changePosition', {
            cover_id: cover_id,
            direction: direction
        }).then((result) => {
                //console.log(result);
                //console.log(albums);
                this.loadCovers()
            }
        );
    }

    onChangeInterval = (e) => {
        this.setState({update_interval: event.target.value});
    }

    changeInterval = () => {
        apiFetch('covers.changeInterval', {
            interval: this.state.update_interval,
        }).then((result) => {
                alert("Интервал обновлен!");
            }
        );
    }

    render() {
        return (
            <React.Fragment><h2>Обложки</h2>
                <hr/>
                <div>
                    <form enctype="multipart/form-data">
                        <input type="file" id="coversUpload" name="covers[]" accept="image/jpeg,image/png,image/gif" multiple  />
                        <Button onClick={() => this.uploadCovers()}>Загрузить</Button>
                    </form>
                </div>
                <div>
                    <Form.Group>
                        <Form.Label>Интервал обновления в часах (0 - отключить обновление)</Form.Label>
                        <Form.Control name="update_interval" value={this.state.update_interval} onChange={this.onChangeInterval} placeholder="Интервал обновления в часах"/>
                        <Button onClick={this.changeInterval}>Обновить</Button>
                    </Form.Group>
                </div>
                <hr/>
                <Table striped bordered hover>
                    <thead>
                    <tr>
                        <th>Обложка</th>
                        <th>Позиция</th>
                        <th>Действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.covers && this.state.covers.map((cover) => {
                        const pathToCover = "/covers/" + cover.filename;
                        const itemId = "cover"+cover.id;
                        return <React.Fragment>{cover ? <tr key={cover.id} id={itemId}>
                            <td><a target="_blank" href={pathToCover}><img width={600} src={pathToCover}/></a></td>
                            <td>
                                <span style={{ cursor: 'pointer'}}><FontAwesomeIcon onClick={() => this.changePosition(cover.id, 'up')} icon={faArrowUp} size={3}/></span>
                                <span style={{ cursor: 'pointer'}}><FontAwesomeIcon onClick={() => this.changePosition(cover.id, 'down')} icon={faArrowDown} size={3}/></span>
                            </td>
                            <td>
                                <FontAwesomeIcon onClick={() => this.deleteCover(cover.id)} icon={faTrashAlt}/>
                            </td>
                        </tr> : null }</React.Fragment>
                    })}
                    </tbody>
                </Table>
            </React.Fragment>
        );
    }
}

export default withRouter(Covers);



// WEBPACK FOOTER //
// ./src/components/Covers.js